<div class="container">
  <h1 class="page-title"><span class="icon"><i class="fas fa-truck"></i></span>{{ 'ImportDeclarationHeaderDetail.Header' | translate }} ({{importHeader?.importDeclarationNo}})</h1>
  <p-card>
      <form class="detail-form" [formGroup]="editForm">
        <div class="field grid">
          <div class="p-fluid field grid">
            <div class="field grid col-6 align-items-baseline">
              <label class="col-4 column-label">{{ 'ImportDeclarationHeaderDetail.ImportNum' | translate }}</label>
              <div class="col-8 column-value">
                {{ importHeader?.importDeclarationNo | replaceNullWith:'-' }}
              </div>
            </div>
            <div class="field grid col-6 align-items-baseline">
              <label class="col-4 column-label"><span class="requiredStart">*</span>{{ 'ImportDeclarationHeaderDetail.Forwarder' | translate }}</label>
              <div class="col-8 column-value">
                <p-dropdown formControlName="forwarder" [filter]="true" [options]="forwarderOptions" [(ngModel)]="importHeader.forwarder"></p-dropdown>
                <small
                  *ngIf="((submitted || editForm.controls.forwarder.touched) && editForm.controls.forwarder.errors?.required)" class="p-invalid">{{ 'Common.Button.Required' | translate }}
                </small>
              </div>
            </div>
            <div class="field grid col-6 align-items-baseline">
              <label class="col-4 column-label"><span class="requiredStart">*</span>{{ 'ImportDeclarationHeaderDetail.PayeeType' | translate }}</label>
              <div class="col-8 column-value">
                <p-dropdown formControlName="billObjectType" [filter]="true" (onChange)="changeBillObject()" [options]="billObjectTypeOptions" [(ngModel)]="importHeader.billObjectType"></p-dropdown>
                <small
                  *ngIf="((submitted || editForm.controls.billObjectType.touched) && editForm.controls.billObjectType.errors?.required)" class="p-invalid">{{ 'Common.Button.Required' | translate }}
                </small>
              </div>
            </div>
            <div class="field grid col-6 align-items-baseline">
              <label class="col-4 column-label"><span class="requiredStart">*</span>{{ 'ImportDeclarationHeaderDetail.Payee' | translate }}</label>
              <div class="col-8 column-value">
                <p-dropdown formControlName="billObject" [filter]="true" [options]="billObjectOptions" [(ngModel)]="importHeader.billObject" placeholder="{{ 'Common.Message.ChooseOption' | translate }}"></p-dropdown>
                <small
                  *ngIf="((submitted || editForm.controls.billObject.touched) && editForm.controls.billObject.errors?.required)" class="p-invalid">{{ 'Common.Button.Required' | translate }}
                </small>
              </div>
            </div>
            <div class="field grid col-6 align-items-baseline">
              <label class="col-4 column-label">{{ 'ImportDeclarationHeaderDetail.Company' | translate }}</label>
              <div class="col-8 column-value">
                {{ importHeader?.orgId | optionsMapping:orgIdOptions | replaceNullWith:'-' }}
              </div>
            </div>
            <div class="field grid col-6 align-items-baseline">
              <label class="col-4 column-label"><span class="requiredStart">*</span>{{ 'ImportDeclarationHeaderDetail.BillCorp' | translate }}</label>
              <div class="col-8 column-value">
                {{ importHeader?.billCorp | optionsMapping:orgIdOptions | replaceNullWith:'-' }}
              </div>
            </div>
            <div class="field grid col-6 align-items-baseline">
              <label class="col-4 column-label">{{ 'ImportDeclarationHeaderDetail.ReceiptFormNum' | translate }}</label>
              <div class="col-8 column-value">
                {{ importHeader?.whNo | replaceNullWith:'-' }}
              </div>
            </div>
            <div class="field grid col-6 align-items-baseline">
              <label class="col-4 column-label">{{ 'ImportDeclarationHeaderDetail.IdentificaitonNum' | translate }}</label>
              <div class="col-8 column-value">
                <input type="text" style="width:15%;" pInputText formControlName="docNo1" maxlength="2" [(ngModel)]="importHeader.docNo1" />/
                <input type="text" style="width:15%;" pInputText formControlName="docNo2" maxlength="2" [(ngModel)]="importHeader.docNo2" />/
                <input type="text" style="width:15%;" pInputText formControlName="docNo3" maxlength="2" [(ngModel)]="importHeader.docNo3" />/
                <input type="text" style="width:15%;" pInputText formControlName="docNo4" maxlength="4" [(ngModel)]="importHeader.docNo4" />/
                <input type="text" style="width:15%;" pInputText formControlName="docNo5" maxlength="5" [(ngModel)]="importHeader.docNo5" />
              </div>
              <small *ngIf="(f.docNo1.errors || f.docNo2.errors || f.docNo3.errors || f.docNo4.errors || f.docNo5.errors)" class="errors">
                <div *ngIf="f.docNo1.errors?.fullWidth || f.docNo2.errors?.fullWidth || f.docNo3.errors?.fullWidth || f.docNo4.errors?.fullWidth || f.docNo5.errors?.fullWidth" class="p-invalid">請輸入半形字符</div>
              </small>
            </div>
            <div class="field grid col-6 align-items-baseline">
              <label class="col-4 column-label">{{ 'ImportDeclarationHeaderDetail.PaymentApplicationNum' | translate }}</label>
              <div class="col-8 column-value">
                <input type="text" pInputText formControlName="apInvoiceId" [(ngModel)]="importHeader.apInvoiceId" />
              </div>
            </div>
            <div class="field grid col-6 align-items-baseline">
              <label class="col-4 column-label">{{ 'ImportDeclarationHeaderDetail.APCreationDate' | translate }}</label>
              <div class="col-8 column-value">
                <p-calendar dataType="string" dateFormat="yy/mm/dd" formControlName="apglDtTimeZone" [(ngModel)]="importHeader.apglDtTimeZone"></p-calendar>
              </div>
            </div>
            <div class="field grid col-6 align-items-baseline">
              <label class="col-4 column-label"><span class="requiredStart">*</span>{{ 'ImportDeclarationHeaderDetail.TradeTerm' | translate }}</label>
              <div class="col-8 column-value">
                <p-dropdown formControlName="incoTerm" [filter]="true" [options]="incoTermOptions" [(ngModel)]="importHeader.incoTerm"
                    placeholder="{{ 'Common.Message.ChooseOption' | translate }}"></p-dropdown>
                <small
                  *ngIf="((submitted || editForm.controls.incoTerm.touched) && editForm.controls.incoTerm.errors?.required)" class="p-invalid">{{ 'Common.Button.Required' | translate }}
                </small>
              </div>
            </div>
            <div class="field grid col-6 align-items-baseline">
              <label class="col-4 column-label">{{ 'ImportDeclarationHeaderDetail.Supplier' | translate }}</label>
              <div class="col-8 column-value">
                <p-dropdown formControlName="vendor" [filter]="true" (onFilter)="getVendorOptions($event)" [options]="vendorOptions" [(ngModel)]="importHeader.vendor"></p-dropdown>
              </div>
            </div>
            <div class="field grid col-6 align-items-baseline">
              <label class="col-4 column-label">{{ 'ImportDeclarationHeaderDetail.DeclarationDate' | translate }}</label>
              <div class="col-8 column-value">
                <p-calendar dataType="string" dateFormat="yy/mm/dd" formControlName="importDtTimeZone" [(ngModel)]="importHeader.importDtTimeZone"></p-calendar>
              </div>
            </div>
            <div class="field grid col-6 align-items-baseline">
              <label class="col-4 column-label"><span class="requiredStart">*</span>{{ 'ImportDeclarationHeaderDetail.CustomsDeclarationMethod' | translate }}</label>
              <div class="col-8 column-value">
                <p-dropdown formControlName="importType" [filter]="true" [options]="importTypeOptions" [(ngModel)]="importHeader.importType"></p-dropdown>
                <small
                  *ngIf="((submitted || editForm.controls.importType.touched) && editForm.controls.importType.errors?.required)" class="p-invalid">{{ 'Common.Button.Required' | translate }}
                </small>
              </div>
            </div>
            <div class="field grid col-6 align-items-baseline">
              <label class="col-4 column-label"><span class="requiredStart">*</span>{{ 'ImportDeclarationHeaderDetail.HAWB' | translate }}</label>
              <div class="col-8 column-value">
                <input type="text" pInputText formControlName="expressBill" [(ngModel)]="importHeader.expressBill" />
                <small
                  *ngIf="((submitted || editForm.controls.expressBill.touched) && editForm.controls.expressBill.errors?.required)" class="p-invalid">{{ 'Common.Button.Required' | translate }}
                </small>
              </div>
            </div>
            <div class="field grid col-6 align-items-baseline">
              <label class="col-4 column-label">{{ 'ImportDeclarationHeaderDetail.MAWB' | translate }}</label>
              <div class="col-8 column-value">
                <input type="text" pInputText formControlName="mawbNo" [(ngModel)]="importHeader.mawbNo" />
              </div>
            </div>
            <div class="field grid col-6 align-items-baseline">
              <label class="col-4 column-label"><span class="requiredStart">*</span>{{ 'ImportDeclarationHeaderDetail.DeclarationType' | translate }}</label>
              <div class="col-8 column-value">
                <p-dropdown formControlName="docType" [filter]="true" [options]="docTypeOptions" [(ngModel)]="importHeader.docType"></p-dropdown>
                <small
                  *ngIf="((submitted || editForm.controls.docType.touched) && editForm.controls.docType.errors?.required)" class="p-invalid">{{ 'Common.Button.Required' | translate }}
                </small>
              </div>
            </div>
            <div class="field grid col-6 align-items-baseline">
              <label class="col-4 column-label">{{ 'ImportDeclarationHeaderDetail.RFQCurrency' | translate }}</label>
              <div class="col-8 column-value">
                <p-dropdown formControlName="currency" [filter]="true" [options]="currencyOptions" [(ngModel)]="importHeader.currency"></p-dropdown>
              </div>
            </div>
            <div class="field grid col-6 align-items-baseline">
              <label class="col-4 column-label"><span class="requiredStart">*</span>{{ 'ImportDeclarationHeaderDetail.ExportCountryCode' | translate }}</label>
              <div class="col-8 column-value">
                <p-dropdown formControlName="exportCountryCode" [filter]="true" (onChange)="changeCityOptions()" [options]="countryOptions" [(ngModel)]="importHeader.exportCountryCode"></p-dropdown>
                <small
                  *ngIf="((submitted || editForm.controls.exportCountryCode.touched) && editForm.controls.exportCountryCode.errors?.required)" class="p-invalid">{{ 'Common.Button.Required' | translate }}
                </small>
              </div>
            </div>
            <div class="field grid col-6 align-items-baseline">
              <label class="col-4 column-label"><span class="requiredStart">*</span>{{ 'ImportDeclarationHeaderDetail.ExportCity' | translate }}</label>
              <div class="col-8 column-value">
                <p-dropdown formControlName="exportCityCode" [filter]="true" [options]="cityOptions" [(ngModel)]="importHeader.exportCityCode"></p-dropdown>
                <small
                  *ngIf="((submitted || editForm.controls.exportCityCode.touched) && editForm.controls.exportCityCode.errors?.required)" class="p-invalid">{{ 'Common.Button.Required' | translate }}
                </small>
              </div>
            </div>
            <div class="field grid col-6 align-items-baseline">
              <label class="col-4 column-label">{{ 'ImportDeclarationHeaderDetail.TaxBillNum' | translate }}</label>
              <div class="col-8 column-value">
                <input type="text" pInputText formControlName="gvTaxNo" [(ngModel)]="importHeader.gvTaxNo" />
              </div>
            </div>
            <div class="field grid col-6 align-items-baseline">
              <label class="col-4 column-label">{{ 'ImportDeclarationHeaderDetail.TaxBillDate' | translate }}</label>
              <div class="col-8 column-value">
                <p-calendar dataType="string" dateFormat="yy/mm/dd" formControlName="gvTaxDtTimeZone" [(ngModel)]="importHeader.gvTaxDtTimeZone"></p-calendar>
              </div>
            </div>
            <div class="field grid col-6 align-items-baseline">
              <label class="col-4 column-label">{{ 'ImportDeclarationHeaderDetail.CustomsExchangeRate' | translate }}</label>
              <div class="col-8 column-value">
                <p-inputNumber formControlName="importRate" [(ngModel)]="importHeader.importRate" mode="decimal" [minFractionDigits]="3" [maxFractionDigits]="3"></p-inputNumber>
              </div>
            </div>
            <div class="field grid col-6 align-items-baseline">
              <label class="col-4 column-label">{{ 'ImportDeclarationHeaderDetail.CustomsAmount' | translate }}</label>
              <div class="col-8 column-value">
                <p-inputNumber formControlName="importAmount" [(ngModel)]="importHeader.importAmount" mode="decimal" [minFractionDigits]="2" [maxFractionDigits]="2"></p-inputNumber>
              </div>
            </div>
            <div class="field grid col-6 align-items-baseline">
              <label class="col-4 column-label">{{ 'ImportDeclarationHeaderDetail.CustomsDutyTax' | translate }}</label>
              <div class="col-8 column-value">
                <p-inputNumber formControlName="importAmountTax" [(ngModel)]="importHeader.importAmountTax" mode="decimal" [minFractionDigits]="2" [maxFractionDigits]="2"></p-inputNumber>
              </div>
            </div>
            <div class="field grid col-6 align-items-baseline">
              <label class="col-4 column-label">{{ 'ImportDeclarationHeaderDetail.CustomsDeclarationAntAC' | translate }}</label>
              <div class="col-8 column-value">
                <p-inputNumber formControlName="importAcctdAmount" [(ngModel)]="importHeader.importAcctdAmount" mode="decimal" [minFractionDigits]="2" [maxFractionDigits]="2"></p-inputNumber>
              </div>
            </div>
            <div class="field grid col-6 align-items-baseline">
              <label class="col-4 column-label">{{ 'ImportDeclarationHeaderDetail.CustomsDutyTaxAC' | translate }}</label>
              <div class="col-8 column-value">
                <p-inputNumber formControlName="importAcctdAmountTax" [(ngModel)]="importHeader.importAcctdAmountTax" mode="decimal" [minFractionDigits]="2" [maxFractionDigits]="2"></p-inputNumber>
              </div>
            </div>
            <div class="field grid col-6 align-items-baseline">
              <label class="col-4 column-label">{{ 'ImportDeclarationHeaderDetail.BusinessTaxBase' | translate }}</label>
              <div class="col-8 column-value">
                <p-inputNumber formControlName="estimatedGvAcctdAmount" [(ngModel)]="importHeader.estimatedGvAcctdAmount" mode="decimal" [minFractionDigits]="2" [maxFractionDigits]="2"></p-inputNumber>
              </div>
            </div>
            <div class="field grid col-6 align-items-baseline">
              <label class="col-4 column-label">{{ 'ImportDeclarationHeaderDetail.TaxAnt' | translate }}</label>
              <div class="col-8 column-value">
                <p-inputNumber formControlName="estimatedGvAcctdAmountTax" [(ngModel)]="importHeader.estimatedGvAcctdAmountTax" mode="decimal" [minFractionDigits]="2" [maxFractionDigits]="2"></p-inputNumber>
              </div>
            </div>
            <div class="field grid col-6 align-items-baseline">
              <label class="col-4 column-label">{{ 'ImportDeclarationHeaderDetail.TradePromotionFee' | translate }}</label>
              <div class="col-8 column-value">
                <p-inputNumber formControlName="estimatedGvAcctdExpBAmount" [(ngModel)]="importHeader.estimatedGvAcctdExpBAmount" mode="decimal" [minFractionDigits]="2" [maxFractionDigits]="2"></p-inputNumber>
              </div>
            </div>
            <div class="field grid col-6 align-items-baseline">
              <label class="col-4 column-label">{{ 'ImportDeclarationHeaderDetail.ImportDutyTax' | translate }}</label>
              <div class="col-8 column-value">
                <p-inputNumber formControlName="estimatedGvAcctdExpCAmount" [(ngModel)]="importHeader.estimatedGvAcctdExpCAmount" mode="decimal" [minFractionDigits]="2" [maxFractionDigits]="2"></p-inputNumber>
              </div>
            </div>
            <div class="field grid col-6 align-items-baseline">
              <label class="col-4 column-label">{{ 'ImportDeclarationHeaderDetail.CargoDutyTax' | translate }}</label>
              <div class="col-8 column-value">
                <p-inputNumber formControlName="estimatedGvAcctdExpDAmount" [(ngModel)]="importHeader.estimatedGvAcctdExpDAmount" mode="decimal" [minFractionDigits]="2" [maxFractionDigits]="2"></p-inputNumber>
              </div>
            </div>
            <div class="field grid col-6 align-items-baseline">
              <label class="col-4 column-label">{{ 'ImportDeclarationHeaderDetail.Remarks' | translate }}</label>
              <div class="col-8 column-value">
                <input type="text" pInputText formControlName="reference" [(ngModel)]="importHeader.reference" />
              </div>
            </div>
            <div class="field grid col-6 align-items-baseline">
              <label class="col-4 column-label">{{ 'ImportDeclarationHeaderDetail.CaseNum' | translate }}</label>
              <div class="col-8 column-value">
                <input type="text" pInputText formControlName="applyNo" [(ngModel)]="importHeader.applyNo" />
              </div>
            </div>
            <div class="field grid col-6 align-items-baseline">
              <label class="col-4 column-label">{{ 'ImportDeclarationHeaderDetail.CreateBy' | translate }}</label>
              <div class="col-8 column-value">
                {{ importHeader?.createUser | replaceNullWith:'-' }}
              </div>
            </div>
            <div class="field grid col-6 align-items-baseline">
              <label class="col-4 column-label">{{ 'ImportDeclarationHeaderDetail.CreationTime' | translate }}</label>
              <div class="col-8 column-value">
                {{ importHeader?.createDt| date:'yyyy-MM-dd HH:mm:ss':this.laasSetting.facilityTimeZone | replaceNullWith:'-' }}
              </div>
            </div>
            <div class="field grid col-6 align-items-baseline">
              <label class="col-4 column-label">{{ 'ImportDeclarationHeaderDetail.LastUpdateBy' | translate }}</label>
              <div class="col-8 column-value">
                {{ importHeader?.updateUser | replaceNullWith:'-' }}
              </div>
            </div>
            <div class="field grid col-6 align-items-baseline">
              <label class="col-4 column-label">{{ 'ImportDeclarationHeaderDetail.UpdateDt' | translate }}</label>
              <div class="col-8 column-value">
                {{ importHeader?.updateDt | date:'yyyy-MM-dd HH:mm:ss':this.laasSetting.facilityTimeZone | replaceNullWith:'-' }}
              </div>
            </div>
          </div>
          <div class="grid">
            <div class="col">
              <button pButton pRipple label="{{ 'Common.Button.Save' | translate }}" (click)="saveBtnClick($event)" class="mr-2"></button>
              <button pButton pRipple label="{{ 'Common.Button.Cancel' | translate }}" (click)="goToLastPage()" class="p-button-secondary"></button>
            </div>
          </div>
        </div>
      </form>
  </p-card>
</div>
